export default __webpack_public_path__ + "static/media/joshc.3df81156.gif";